import { __rest } from "tslib";
import React, { useEffect, useState, useCallback } from 'react';
import { Modal, Input, Divider, Select, Form, Space } from 'antd';
import styles from './mailSenderSetting.module.scss';
import { OverlayScrollbarsComponent } from 'overlayscrollbars-react';
import { apiHolder as api, apis } from 'api';
import useMsgRenderCallback from '@web-common/hooks/useMsgRenderCallback';
import TriangleDownIcon from '@web-common/components/UI/Icons/svgs/TriangleDown';
import { ReactComponent as DeleteIcon } from '@/images/icons/modal_close_temp.svg';
import { useAppSelector } from '@web-common/state/createStore';
import { getIn18Text } from 'api';
const { Option } = Select;
export var SenderSettingType;
(function (SenderSettingType) {
    SenderSettingType["NICKNAME_SETTING"] = "NICKNAME_SETTING";
    SenderSettingType["SENDER_SETTING"] = "SENDER_SETTING";
})(SenderSettingType || (SenderSettingType = {}));
const mailConfApi = api.api.requireLogicalApi(apis.mailConfApiImpl);
const MailSenderSetting = ({ isShow, handleSubmit = () => { }, setVisible = () => { }, type }) => {
    const tag = '[MailSenderSetting]';
    const [mailAliasAccount, setMailAliasAccount] = useState([]);
    const [mailProxyAccount, setMailProxyAccount] = useState([]);
    const [list, setList] = useState([]);
    const [curId, setCurId] = useState({ name: '', id: '', domain: '', nickName: '', senderName: '' });
    const [defaultSenderId, setDefaultSenderId] = useState('');
    const { currentMail } = useAppSelector(state => state.mailReducer);
    const [form] = Form.useForm();
    const getMailAliasAccountList = () => {
        mailConfApi.getMailSenderInfo().then((rs) => {
            if (rs && rs.length > 0) {
                setMailAliasAccount(rs
                    .filter(item => !item.isProxy)
                    .sort((a, b) => {
                    if (a.isMainEmail) {
                        return -1;
                    }
                    if (b.isMainEmail) {
                        return 1;
                    }
                    return 0;
                }));
                const popoAccounts = rs.filter(item => item.isProxy);
                setMailProxyAccount(popoAccounts);
                form.setFieldsValue({ popoAccounts });
                setList(rs);
                const mainSender = rs.find(item => item.isMainEmail);
                if (mainSender) {
                    setCurId(mainSender);
                    form.setFieldsValue({ senderName: mainSender.senderName });
                }
                const defualtSender = rs.find(item => item.isDefault);
                if (defualtSender) {
                    setDefaultSenderId(defualtSender.id);
                    form.setFieldsValue({ defulatSender: defualtSender.id });
                }
            }
        });
    };
    useMsgRenderCallback('mailAliasAccountListChange', ev => {
        var _a;
        if (((_a = ev === null || ev === void 0 ? void 0 : ev.eventData) === null || _a === void 0 ? void 0 : _a.mailId) === currentMail.cid) {
            getMailAliasAccountList();
        }
    });
    useEffect(() => {
        if (isShow) {
            getMailAliasAccountList();
        }
    }, [isShow]);
    const handleOk = useCallback(async () => {
        form
            .validateFields()
            .then(async (values) => {
            console.log('Received values of form:', values);
            const { popoAccounts = [], defulatSender, senderName } = values;
            let hasChanged = false;
            const validProxyAccounts = popoAccounts.filter((item, idx) => item.senderName !== mailProxyAccount[idx].senderName);
            if (validProxyAccounts.length > 0) {
                hasChanged = true;
                await mailConfApi.doUpdatePOPAccounts(validProxyAccounts.map((item) => { var _a; return ({ id: item.editId, name: (_a = item.senderName) === null || _a === void 0 ? void 0 : _a.trim() }); }));
            }
            if (senderName && senderName !== curId.senderName) {
                hasChanged = true;
                await mailConfApi.setMailSenderName(senderName === null || senderName === void 0 ? void 0 : senderName.trim());
            }
            if (defulatSender && defulatSender !== defaultSenderId) {
                hasChanged = true;
                await mailConfApi.setDefaultSender(defulatSender);
            }
            setVisible(false);
            handleSubmit(hasChanged);
        })
            .catch(info => {
            console.log('Validate Failed:', info);
        });
    }, [mailProxyAccount]);
    const handleCancel = useCallback(() => {
        setVisible(false);
    }, []);
    const handleSenderSelectChange = useCallback(val => {
        console.log('handleSenderSelectChange', val);
        setDefaultSenderId(val);
    }, []);
    const handleInputBlur = useCallback((e, key, index) => {
        console.log(tag, 'handleInputBlur', e.target.value, key, index);
        const val = e.target.value;
        if (!val) {
            if (key === 'popoAccounts') {
                const originVal = mailProxyAccount[index];
                form.setFieldsValue({ popoAccounts: form.getFieldValue('popoAccounts').map((item, idx) => (index === idx ? originVal : item)) });
            }
            else {
                form.resetFields([key]);
            }
        }
    }, [mailProxyAccount]);
    const senderContent = (React.createElement("div", { className: styles.mailSenderContent },
        React.createElement(Form.Item, { name: "defulatSender", initialValue: defaultSenderId, label: getIn18Text('MORENFAJIANREN'), className: styles.mailSenderContentSelect },
            React.createElement(Select, { dropdownClassName: styles.selectDropdown, value: defaultSenderId, suffixIcon: React.createElement(TriangleDownIcon, null), onChange: handleSenderSelectChange }, list.map(item => (React.createElement(Option, { key: item.id, default: item.isDefault, value: item.id }, item.id)))))));
    return (React.createElement(Modal, { onOk: handleOk, onCancel: handleCancel, className: `ant-allow-dark ${styles.mailNicknameContainer}`, closeIcon: React.createElement(DeleteIcon, null), title: type === SenderSettingType.NICKNAME_SETTING ? getIn18Text('XIUGAIFAJIANREN') : getIn18Text('FAJIANRENSHEZHI'), okText: getIn18Text('BAOCUN'), cancelText: getIn18Text('QUXIAO'), visible: isShow, width: "745px", destroyOnClose: true },
        React.createElement(OverlayScrollbarsComponent, { style: { maxHeight: '350px' } },
            React.createElement(Form, { preserve: false, requiredMark: false, form: form, name: "mail_sender_setting", colon: false },
                React.createElement("div", { className: styles.mailNicknameContent },
                    type === SenderSettingType.SENDER_SETTING && senderContent,
                    type === SenderSettingType.SENDER_SETTING && React.createElement("span", { className: styles.mailNicknameContentTitle }, getIn18Text('BIANJIFAJIANREN')),
                    React.createElement("div", { className: styles.mailListItem },
                        React.createElement("div", { className: styles.mailListItemInputField },
                            React.createElement(Form.Item, { name: "senderName", initialValue: curId.senderName, label: getIn18Text('FAJIANRENNICHENG') },
                                React.createElement(Input, { maxLength: 50, className: styles.mailListItemInput }))),
                        React.createElement("div", { className: styles.mailListItemAddr }, mailAliasAccount.map(item => (React.createElement("div", { className: styles.mailListItemAddrItem },
                            React.createElement("label", null, item.isMainEmail ? getIn18Text('YOUXIANGDEZHI') : getIn18Text('YOUXIANGBIEMING')),
                            React.createElement("span", null, item.id)))))),
                    type === SenderSettingType.NICKNAME_SETTING && mailProxyAccount.length > 0 && React.createElement(Divider, null),
                    React.createElement(Form.List, { name: "popoAccounts", initialValue: mailProxyAccount }, fields => fields.map((_a) => {
                        var { name, key } = _a, rest = __rest(_a, ["name", "key"]);
                        return (React.createElement(Space, { key: key, align: "baseline" },
                            React.createElement("div", { className: styles.mailListItem },
                                React.createElement("div", { className: styles.mailListItemInputField },
                                    React.createElement(Form.Item, Object.assign({ name: [name, 'senderName'], label: getIn18Text('FAJIANRENNICHENG') }, rest),
                                        React.createElement(Input, { maxLength: 12, onBlur: e => handleInputBlur(e, 'proxy_account', key), className: styles.mailListItemInput })),
                                    React.createElement("label", null, getIn18Text('(DAIFA)YOU')),
                                    React.createElement("span", null, form.getFieldValue('popoAccounts')[key].id)))));
                    })))))));
};
export default MailSenderSetting;
